export default "__VITE_ASSET__D$aLOw14__"